import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";

Vue.use(Toast);
const LOTTERY_LANGS = ['zh_cn', 'en_us', 'es_spa', 'ms_my', 'kor', 'jp'];
//创建axios实例对象
const instance = axios.create({
    baseURL: 'https://api.70x4dzli.com/api', //服务器地址
    timeout: 50000, //默认超时时长
})

//请求拦截器
instance.interceptors.request.use(config => {
    if (config.method === "post") {
        config.headers = {
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8', // 设置跨域头部
        }
    }
    // if(localStorage.getItem('token')){
    let lang = 'en_us'
    if (localStorage.getItem("lang")) {
        lang = localStorage.getItem("lang").toLowerCase()
    }
    // 彩票接口后端只有这几种语言的名称字段，其它语言会直接报错
    if (/^\/Lottery\//i.test(config.url) && !LOTTERY_LANGS.includes(lang)) {
        lang = 'en_us'
    }
    config.headers = {
        'token': Base64.encode(localStorage.getItem('token')),
        'lang': lang
    }
    // }
    return config
}, err => {
    console.error('Request failed', err)
})

//响应拦截器
instance.interceptors.response.use(res => {
    //此处对响应数据做处理
    if (res.data.msg === "鉴权错误" || res.data.msg === "인증 오류" || res.data.msg === "Authentication error") {
        localStorage.clear();
        this.$router.push({ path: '/Login' })
    }
    return res //该返回对象会传到请求方法的响应对象中
}, err => {
    // 响应错误处理
    return Promise.reject(err);
})

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
// 统一解析响应：优先使用 sdata；兼容旧接口的 base64 data 字段
function unwrapResponse(body) {
    if (!body || typeof body !== 'object') return body
    if (body.sdata !== undefined && body.sdata !== null) {
        body.data = body.sdata
        return body
    }
    if (typeof body.data === 'string' && body.data) {
        try {
            body.data = JSON.parse(Base64.decode(body.data))
        } catch (e) {
            // 保留原始 data，避免解析失败导致整个请求不可用
        }
    }
    return body
}

async function http(option = {}) {
    let result = null
    if (option.method === 'get' || option.method === 'delete') {
        //处理get、delete请求
        await instance[option.method](
            api[option.url],
            { params: option.data }
        ).then(res => {
            result = unwrapResponse(res.data)
        }).catch(err => {
            result = err
        })
    } else if (option.method === 'post' || option.method === 'put') {
        //处理post、put请求
        await instance[option.method](
            api[option.url],
            qs.stringify(option.data)
        ).then(res => {
            result = unwrapResponse(res.data)
        }).catch(err => {
            result = err
        })
    }
    return result
}

export default http

